import { render, staticRenderFns } from "./Ccl.vue?vue&type=template&id=65b72edc&scoped=true&"
import script from "./Ccl.vue?vue&type=script&lang=js&"
export * from "./Ccl.vue?vue&type=script&lang=js&"
import style0 from "./Ccl.vue?vue&type=style&index=0&id=65b72edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b72edc",
  null
  
)

export default component.exports